import { useSelector } from 'react-redux';
import styles from '../branches.module.css';

const AgencyUserCount = () => {
	const agency = useSelector((state) => state.user.agency);
	return (
		<div className={styles.userCountWrapper}>
			<div className={styles.userTitleWrapper}>
				<p>Agency User Count:</p>
			</div>
			<div className={styles.userValueWrapper}>
				{agency.agencyUserCount}
				{agency.purchasedSeatQuantity
					? ` / ${agency.purchasedSeatQuantity} seats`
					: null}
			</div>
		</div>
	);
};

export default AgencyUserCount;
